<template>
  <footer class="footer">
    <div class="footer__top">
      <div class="relative footer__map">
        <div :style="`background-image: url('${map}')`" class="footer__map-image"></div>
        <div class="footer__address">
          <RightAddressLink :content="contact.address" class="footer__address-panel --footer" />
          <Icon id="marker" class="footer__marker" />
        </div>
      </div>
      <div class="footer__contact" id="contact">
        <div class="footer__top-top">
          <h2 class="footer__title">{{ $t('footer.contact') }}</h2>
          <div class="footer__links">
            <a :href="contact.address.link" class="footer__link" target="_blank">
              <Icon id="marker" />
              <div class="footer__link-text">
                <p>{{ `${contact.address.address},` }}</p>
                <p>
                  {{
                    `${contact.address.postal_code} ${contact.address.city}, ${contact.address.state}`
                  }}
                </p>
              </div>
            </a>
            <a :href="telephone(contact.phone)" class="footer__link" target="_blank">
              <Icon id="phone" />
              <span class="footer__link-text">{{ contact.phone }}</span>
            </a>
            <a :href="`mailto:${contact.email.toLowerCase()}`" class="footer__link" target="_blank">
              <Icon id="mail" />
              <span class="footer__link-text">{{ contact.email }}</span>
            </a>
            <LangRouterLink :to="{ name: 'faq' }" class="footer__link">
              <Icon id="question" />
              <span class="footer__link-text">{{ $t('faq.title') }}</span>
            </LangRouterLink>
          </div>
        </div>
        <div class="footer__top-bottom">
          <div>
            <h2 class="footer__title">{{ $t('footer.follow') }}</h2>
            <div class="footer__media-group">
              <a
                class="footer__media"
                :href="media.link"
                v-for="(media, mediaKey) in medias"
                :key="mediaKey"
                :title="capitalize(media.name)"
              >
                <Icon :id="media.name" />
              </a>
            </div>
          </div>
          <div class="footer__embed">
            <a
              href="https://www.ca.kayak.com/Quebec-Hotels-Hotel-Boutique-Ophelia.8790155.lfr.ksp"
              target="_blank"
            >
              <img
                src="data:image/png;base64,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"
              />
            </a>
          </div>
        </div>
        <Button :link="contact.maestro.link" :label="contact.maestro.title" class="--footer" />
      </div>
    </div>
    <div class="footer__bottom">
      <div>
        <p>{{ $t('footer.copyright').replace(':YEAR', new Date().getFullYear().toString()) }}</p>
        <p v-if="contact.certificate">
          {{ contact.certificate?.label }} : {{ contact.certificate?.number }}
        </p>
      </div>
      <a
        v-if="$beet.options.contact.privacy.link"
        :href="$beet.options.contact.privacy.link"
        target="_blank"
        rel="nofollow"
      >
        {{ $beet.options.contact.privacy.label }}
      </a>
      <a href="https://boitebeet.com/" target="_blank">
        <RawHtml :html="$t('footer.design')"></RawHtml>
      </a>
    </div>
  </footer>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import RawHtml from '@/components/global/RawHtml.vue'
import Button from '@/components/small/Button.vue'
import RightAddressLink from '@/components/small/RightAddressLink.vue'

export default {
  name: 'Footer',
  components: { Button, RightAddressLink, LangRouterLink, Icon, RawHtml },
  data() {
    return {
      map: 'https://assets.boitebeet.com/hotel-ophelia/69/map.jpg',
    }
  },
  computed: {
    contact() {
      return {
        address: {
          address: this.$beet.options.contact.address,
          city: this.$beet.options.contact.city,
          link: this.$beet.options.contact.map_link,
          postal_code: this.$beet.options.contact.postal_code,
          state: this.$beet.options.contact.state,
        },
        email: this.$beet.options.contact.email,
        maestro: {
          link: this.$beet.options.contact.maestro.link.toString(),
          title: this.$beet.options.contact.maestro.label.toString(),
        },
        phone: this.$beet.options.contact.phone,
        certificate: this.$beet.options.contact.certificate,
      }
    },
    medias() {
      return [
        {
          link: this.$beet.options.contact.facebook,
          name: 'facebook',
        },
        {
          link: this.$beet.options.contact.instagram,
          name: 'instagram',
        },
      ]
    },
  },
  methods: {
    capitalize(word) {
      return `${word.charAt(0).toUpperCase()}${word.slice(0, 1)}`
    },
    telephone(number) {
      return `tel:${number.replace('(', '').replace(')', '').replace(' ', '-')}`
    },
  },
}
</script>
